import { Controller } from "@hotwired/stimulus"

const ANIMATION_DURATION = 300
const FAILURE_TIMEOUT = 20000

export default class extends Controller {
  static targets = ["inputs", "spinner", "error"]

  connect() {
    this.submitted = false
  }

  submit(event) {
    if (this.submitted) return
    this.submitted = true

    this.disableSubmitButton(event.target)

    this.transitionTo("loading")

    this.timeout = setTimeout(() => {
      this.transitionTo("error")
    }, FAILURE_TIMEOUT)
  }

  transitionTo(state) {
    switch (state) {
      case "loading":
        this.hide(this.inputsTarget)
        setTimeout(() => this.show(this.spinnerTarget), ANIMATION_DURATION)
        break

      case "error":
        this.hide(this.spinnerTarget)
        setTimeout(() => this.show(this.errorTarget), ANIMATION_DURATION)
        break
    }
  }

  hide(target) {
    target.classList.add("opacity-0", "scale-95", "pointer-events-none")

    setTimeout(() => {
      target.classList.add("hidden")
    }, ANIMATION_DURATION)
  }

  show(target) {
    target.classList.remove("hidden")

    requestAnimationFrame(() => {
      target.classList.remove("opacity-0", "scale-95", "pointer-events-none")
      target.classList.add("opacity-100", "scale-100")
    })
  }

  disableSubmitButton(form) {
    const button = form.querySelector('button[type="submit"]')
    if (!button) return

    button.disabled = true
    button.classList.add("opacity-60", "cursor-not-allowed")
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
